import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import ProductLinkButton from '../ProductLinkButton';

const PriceAdjustButton = ({ classes, hidePriceAdjust, onClick, price }) => {
  const initialPrice = React.useMemo(() => {
    if (price.adjustedPrice) {
      return price.promoPrice || price.currentPrice;
    }
    if (price.promoPrice) {
      return price.currentPrice;
    }

    if (price.adjustedPrice) {
      return price.currentPrice;
    }
  }, [price]);

  return (
    <>
      {!hidePriceAdjust && <ProductLinkButton onClick={onClick} data-testid="price-adjust" buttonText="Adjust" />}
      {initialPrice && <Typography className={classes.text}>${initialPrice}</Typography>}
    </>
  );
};

PriceAdjustButton.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  hidePriceAdjust: PropTypes.bool,
  onClick: PropTypes.func,
  price: PropTypes.shape({
    adjustedPrice: PropTypes.string,
    currentPrice: PropTypes.string,
  }),
};

PriceAdjustButton.defaultProps = {
  classes: {},
  hidePriceAdjust: false,
  onClick: () => {},
  price: {},
};

export default PriceAdjustButton;
